import { AxiosPromise } from 'axios';
import request from '@/utils/request';

import {
  PlayerListQuery,
  FifaPlayerListAppVo,
  PlayerDetailQuery,
  FifaPlayerDetailAppVo,
  PlayerTeamListQuery,
  FifaPlayerTeamListAppVo,
  PlayerCheapestListQuery,
  FifaCheapestPlayerVo
} from './type';
/**
 * 球员列表
  GET /product/api/fifa/player/list
  接口ID：235194320
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-235194320
 */
export const getPlayerList = (params: PlayerListQuery): AxiosPromise<FifaPlayerListAppVo[]> => {
  return request({
    url: '/product/api/fifa/player/list',
    method: 'get',
    params
  });
};

/**
 * 查询球员详情
  GET /product/api/fifa/player/detail
  接口ID：235766877
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-235766877
 */
export const getPlayerDetail = (params: PlayerDetailQuery): AxiosPromise<FifaPlayerDetailAppVo> => {
  return request({
    url: '/product/api/fifa/player/detail',
    method: 'get',
    params
  });
};

/**
 * 查看球队列表
  GET /product/api/fifa/player/team/list
  接口ID：235194319
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-235194319
 */
export const getPlayerTeamList = (params: PlayerTeamListQuery): AxiosPromise<FifaPlayerTeamListAppVo[]> => {
  return request({
    url: '/product/api/fifa/player/team/list',
    method: 'get',
    params
  });
};

/**
 * 最便宜球员列表
  GET /product/api/fifa/player/cheapest/list
 */
export const getPlayerCheapestList = (params: PlayerCheapestListQuery): AxiosPromise<FifaCheapestPlayerVo> => {
  return request({
    url: '/product/api/fifa/player/cheapest/list',
    method: 'get',
    params
  });
};
